import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { testLogin } from '../services/api';

/**
 * Test Login Page (Temporary — for development only)
 * Generates a mock JWT, stores in Redis, sets cookie, redirects to /examportal
 */
function TestLogin() {
  const navigate = useNavigate();
  const [candidateId, setCandidateId] = useState('CAND-001');
  const [name, setName] = useState('John Doe');
  const [process, setProcess] = useState('billing');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleStart = async () => {
    setLoading(true);
    setError('');

    try {
      const result = await testLogin(candidateId, name, process);
      if (result.redirect_url) {
        navigate(result.redirect_url);
      }
    } catch (err) {
      setError('Login failed. Is the backend running?');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="test-login-page">
      <div className="login-card">
        <h1>Comms Coach — Test Login</h1>
        <p className="subtitle">Development only. Generates a test JWT token.</p>

        <div className="form-group">
          <label htmlFor="candidateId">Candidate ID</label>
          <input
            id="candidateId"
            type="text"
            value={candidateId}
            onChange={(e) => setCandidateId(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="process">Process</label>
          <select
            id="process"
            value={process}
            onChange={(e) => setProcess(e.target.value)}
          >
            <option value="sales">Sales</option>
            <option value="billing">Billing</option>
            <option value="technical">Technical</option>
            <option value="retention">Retention</option>
          </select>
        </div>

        {error && <p className="error-message">{error}</p>}

        <button
          className="start-button"
          onClick={handleStart}
          disabled={loading || !candidateId || !name}
        >
          {loading ? 'Starting...' : 'Start Assessment'}
        </button>
      </div>
    </div>
  );
}

export default TestLogin;
